import { useDispatch } from 'react-redux'
import type { AppDispatch } from '@/stores'

// use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch
